import { Check } from "lucide-react";

const AppMobile = () => (
  <section className="relative bg-white py-14">
    <div className="mx-auto max-w-6xl px-6">
      <div className="grid items-center gap-12 rounded-[2rem] border border-slate-100 bg-gradient-to-br from-sky-50 via-white to-pink-50 p-8 shadow-sm md:p-14 lg:grid-cols-2">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full border border-pink-200 bg-pink-50 px-3 py-1 text-[11px] font-bold uppercase tracking-widest text-pink-600">
            App Silicomlan
          </div>
          <h2 className="mt-5 text-3xl font-black leading-tight text-slate-900 md:text-5xl">
            Tu cuenta,{" "}
            <span className="bg-gradient-to-r from-pink-500 to-sky-500 bg-clip-text text-transparent">
              en tu bolsillo
            </span>
          </h2>
          <p className="mt-4 text-slate-600 md:text-lg">
            Descargá la app de Silicomlan y gestioná todo desde tu celular.
          </p>

          <ul className="mt-6 grid gap-2 sm:grid-cols-2">
            {[
              "Descargá tus facturas",
              "Seguí tus reclamos",
              "Consultá tu saldo",
              "Contactá soporte",
            ].map((x) => (
              <li
                key={x}
                className="flex items-start gap-2 text-sm text-slate-700"
              >
                <Check className="mt-0.5 h-4 w-4 flex-shrink-0 text-pink-500" />
                {x}
              </li>
            ))}
          </ul>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <a
              href="https://play.google.com/store/apps/details?id=silicomlan.ispcube.com"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Google Play"
                className="h-12"
              />
            </a>
            <span className="text-xs uppercase tracking-widest text-slate-500">
              Disponible en Google Play
            </span>
          </div>
        </div>

        <div className="relative">
          <div className="absolute -inset-6 rounded-[2rem] bg-gradient-to-br from-pink-200/50 to-sky-200/50 blur-2xl" />
          <div className="relative overflow-hidden rounded-[2rem] border border-white shadow-2xl">
            <img
              src="https://customer-assets.emergentagent.com/job_silicom-pro-futbol/artifacts/s1btkpth_Captura%20de%20pantalla%202026-05-06%20a%20la%28s%29%2023.21.57.png"
              alt="App Silicomlan en tu celular"
              className="w-full"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AppMobile;
